export const EMPLOYER_ROUTES = {
  HOME: {
    DASHBOARD: '/',
    OLD_DASHBOARD: '/dashboard',
  },
  JOBS: {
    VIEW_JOB: '/job',
    JOBS_LIST: '/jobs',
    EDIT_JOB: '/job/edit',
    CREATE_JOB: '/job/create',
  },
  APPRENTICESHIPS: {
    VIEW_APPRENTICESHIP: '/apprenticeship',
    APPRENTICESHIPS_LIST: '/apprenticeships',
    EDIT_APPRENTICESHIP: '/apprenticeship/edit',
    CREATE_APPRENTICESHIP: '/apprenticeship/create',
  },
  TALENT_EXCHANGE: {
    STUDENTS_LIST: '/talent-exchange',
  },
  OPPORTUNITY_LINK: {
    PARTNER_DIRECTORY: '/opportunity-link/partner-directory',
    PARTNER_DETAILS: '/opportunity-link/partner-details',
    COHORTS: '/opportunity-link/cohorts',
  },
  TALENT_HUB: {
    TALENT_READY: '/talentReady',
    EMERGING_TALENT: '/emergingTalent',
    PROGRAM_ENROLLMENTS: '/program-interests/:programID',
  },
  ADMIN: {
    ADD_USER: '/adduser',
    USER_MANAGEMENT: '/user/management',
  },
  COMPANY_SETTINGS: {
    SETTINGS: '/company-settings',
  },
  SEND: {
    EMAIL: '/send/message',
  },
  // footer
  FOOTER: {
    REPORT_ABUSE: '/report-abuse',
    ACCESSIBILITY: '/accessibility',
    EMPLOYER_ABOUT_US: 'https://goeducatecorp.com',
    EMPLOYER_TERMS_OF_USE: '/employer-terms-of-use',
    EMPLOYER_PRIVACY_POLICY: '/employer-privacy-policy',
  },
  // ANT Routes
  OPPORTUNITIES: {
    ADD_OPPORTUNITY: '/add/opportunity',
    OPPORTUNITIES_LIST: '/opportunities',
    OPPORTUNITY_DETAILS: '/opportunity',
  },
  EVENTS: {
    EVENTS_LIST: '/events',
    ADD_EVENT: '/addevent',
    EDIT_EVENT: '/editevent',
  },
  WORKFORCE: {
    STUDENT_PROFILE: '/workforce/student-profile',
    STUDENT_EXCHANGE: '/workforce/student-exchange',
  },
  EMPLOYER_PROFILE: {
    CREATE_PROFILE: '/employer-profile',
  },
  SEND: {
    EMAIL: '/send/message',
  },
};
